var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLinkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 14,
    viewBox: "0 0 25 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1263 0.75853L24.7416 6.37585C25.0861 6.72056 25.0861 7.27944 24.7416 7.62415L19.1263 13.2415C18.7817 13.5862 18.223 13.5862 17.8785 13.2415C17.5339 12.8968 17.5339 12.3379 17.8785 11.9932L21.9875 7.88268L0.882353 7.88268C0.395043 7.88268 -7.01231e-08 7.48749 0 7C7.01231e-08 6.51251 0.395043 6.11732 0.882353 6.11732L21.9875 6.11732L17.8785 2.00682C17.5339 1.66212 17.5339 1.10324 17.8785 0.75853C18.223 0.413823 18.7817 0.413823 19.1263 0.75853Z",
    fill: "#204EE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkArrow);
export default __webpack_public_path__ + "static/media/ic-linkArrow.1e18ca42a22ffb02f08c524b06f9c158.svg";
export { ForwardRef as ReactComponent };